export default {
  // 通用
  search: '搜索',
  filter: '筛选',
  export: '导出',
  confirm: '确认',
  cancel: '取消',
  save: '保存',
  delete: '删除',
  edit: '编辑',
  submit: '提交',
  reset: '重置',
  all: '全部',
  
  // 航班状态
  inFlight: '飞行中',
  scheduled: '待起飞',
  planning: '排期中',
  completed: '已完成',
  abnormal: '异常',
  
  // 导航
  home: '首页',
  flights: '航班',
  flightList: '航班列表',
  notifications: '通知',
  profile: '我的',
  
  // 首页
  appName: '航空货运管理',
  welcome: '欢迎回来',
  overview: '概览',
  todayFlights: '今日航班',
  abnormalAlerts: '异常提醒',
  recentUpdates: '最新动态',
  quickAccess: '快速入口',
  allFlights: '全部航班',
  progress: '进度',
  unread: '未读',
  viewAll: '查看全部',
  viewDetails: '查看详情',
  cargoWeight: '货重',
  abnormalCount: '个异常',
  
  // 航班列表
  flightNumber: '航班号',
  route: '航线',
  departureTime: '起飞时间',
  arrivalTime: '到达时间',
  status: '状态',
  progressLabel: '进度',
  
  // 筛选
  filterByStatus: '按状态筛选',
  filterByRoute: '按航线筛选',
  filterByDate: '按日期筛选',
  sortBy: '排序方式',
  
  // 节点
  nodeProgress: '节点进度',
  cargoStatus: '货物状态',
  updateTime: '更新时间',
  operator: '操作人',
  
  // 异常
  abnormalReport: '异常报告',
  abnormalType: '异常类型',
  abnormalDesc: '异常描述',
  handleStatus: '处理状态',
  
  // 通知
  systemNotification: '系统通知',
  flightUpdate: '航班更新',
  abnormalAlert: '异常提醒',
  markAsRead: '标记已读',
  
  // 登录
  login: '登录',
  username: '用户名',
  password: '密码',
  rememberMe: '记住我',
  forgotPassword: '忘记密码',
  
  // 其他
  loading: '加载中...',
  noData: '暂无数据',
  loadMore: '加载更多',
  refresh: '刷新',
  total: '共',
  items: '条',
};